/* ORINOVAE — product main image hover magnifier (desktop only).
 *
 * The CSS in sections/main-product.liquid does the scaling on :hover.
 * This script only tracks the cursor so the zoom origin follows the pointer,
 * which is what makes it feel like a real magnifier.
 *
 * Written with event delegation so it keeps working when the theme swaps the
 * main image after a variant change (no re-binding needed).
 */
(function () {
  var MQ = window.matchMedia('(min-width: 750px)');
  var SELECTOR = '.product__media-item .product-media-container';
  var rafId = null;
  var pending = null;

  function flush() {
    rafId = null;
    if (!pending) return;
    var img = pending.img;
    img.style.transformOrigin = pending.x + '% ' + pending.y + '%';
    pending = null;
  }

  function onMove(event) {
    if (!MQ.matches) return;
    var target = event.target;
    if (!target || !target.closest) return;

    var container = target.closest(SELECTOR);
    if (!container) return;

    var img = container.querySelector('img');
    if (!img) return;

    var rect = container.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var x = ((event.clientX - rect.left) / rect.width) * 100;
    var y = ((event.clientY - rect.top) / rect.height) * 100;

    pending = {
      img: img,
      x: Math.max(0, Math.min(100, x)),
      y: Math.max(0, Math.min(100, y))
    };

    if (!rafId) rafId = window.requestAnimationFrame(flush);
  }

  function reset(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var container = target.closest(SELECTOR);
    if (!container) return;
    var img = container.querySelector('img');
    if (img) img.style.transformOrigin = '';
  }

  document.addEventListener('mousemove', onMove, { passive: true });
  document.addEventListener('mouseout', reset, { passive: true });

  // 触屏设备横屏 / 窗口缩放时，清理残留的 origin
  MQ.addEventListener('change', function () {
    if (MQ.matches) return;
    document.querySelectorAll(SELECTOR + ' img').forEach(function (img) {
      img.style.transformOrigin = '';
    });
  });
})();
